import { useEffect, useState } from "react";
import { Competition, emptyCompetition } from "../../../interfaces/competition";
import { Media } from "../../../interfaces/media";
import { getCompetitionSingle } from "../../../services/competition";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../general/loading-spinner";
import { t } from "i18next";

export function CompetitionView() {
    const params: any = useParams();

    const [loaded, setLoaded] = useState(false);
    const [competition, setCompetition] = useState<Competition>(emptyCompetition);

    useEffect(() => {
        getCompetitionSingle(params.id)
            .then(response => {
                setCompetition(response.data);
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <div className="competition-view-container">
            <div className="inner">
                { !loaded &&
                    <LoadingSpinner />
                }
                { loaded &&
                    <>
                        <h1>{ competition.name }</h1>
                        <div className="content-data content-box competition-view-card">
                            <dl className="competition-meta">
                                <dt className="meta-label">
                                    <i className="bi bi-calendar-event"></i>{ t('Date') }
                                </dt>
                                <dd className="meta-value">{ competition.date_description }</dd>

                                { competition.venue_name &&
                                    <>
                                        <dt className="meta-label">
                                            <i className="bi bi-geo-alt"></i>{ t('venue_name') }
                                        </dt>
                                        <dd className="meta-value">{ competition.venue_name }</dd>
                                    </>
                                }

                                { competition.venue_link &&
                                    <>
                                        <dt className="meta-label">
                                            <i className="bi bi-link-45deg"></i>{ t('venue_link') }
                                        </dt>
                                        <dd className="meta-value">
                                            <a href={ competition.venue_link } target="_blank" rel="noopener noreferrer">
                                                { competition.venue_link }
                                                <i className="bi bi-box-arrow-up-right ms-1"></i>
                                            </a>
                                        </dd>
                                    </>
                                }
                            </dl>

                            { competition.description &&
                                <div className="competition-description">
                                    { competition.description }
                                </div>
                            }

                            { competition.documents && competition.documents.length > 0 &&
                                <div className="competition-documents-section">
                                    <h3>
                                        <i className="bi bi-paperclip"></i>{ t('Documents') }
                                    </h3>
                                    <ul className="competition-documents">
                                        { competition.documents.map((m: Media) => (
                                            <li key={ m.id }>
                                                <a href={ m.url } target="_blank" rel="noopener noreferrer" title={ m.name }>
                                                    <i className="bi bi-file-earmark-pdf"></i>
                                                    <span>{ m.name }</span>
                                                    <i className="bi bi-box-arrow-up-right ms-auto"></i>
                                                </a>
                                            </li>
                                        )) }
                                    </ul>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
        </div>
    );
}
